/**
* 订单管理 交易订单
*/
<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>用户订单</el-breadcrumb-item>
    </el-breadcrumb>
    <!-- 搜索筛选 -->
    <el-form :inline="true" :model="formInline" class="user-search">
      <el-form-item>
        <el-button size="small" type="primary" icon="el-icon-search" @click="search">搜索</el-button>
      </el-form-item>
    </el-form>
    <!--列表-->
    <el-table size="small" :data="listData" highlight-current-row v-loading="loading" border
      element-loading-text="拼命加载中" style="width: 100%;">
      <el-table-column prop="supplierSubOrderNo" label="id" show-overflow-tooltip>
      </el-table-column>
      <el-table-column prop="spuName" label="商品名" show-overflow-tooltip>
      </el-table-column>
      <el-table-column prop="skuSpecDesc" label="规格" show-overflow-tooltip>
      </el-table-column>
      <el-table-column prop="skuActPrice" label="订单金额" show-overflow-tooltip>
      </el-table-column>
      <el-table-column prop="skuPrice" label="实付金额" show-overflow-tooltip>
      </el-table-column>
      <el-table-column prop="itemPrice" label="供货价格" show-overflow-tooltip>
      </el-table-column>
      <el-table-column prop="logisticsCompany" label="快递公司" show-overflow-tooltip>
      </el-table-column>
      <el-table-column prop="logisticsCode" label="物流单号" show-overflow-tooltip>
      </el-table-column>
      <el-table-column prop="logisticsStatusDesc" label="快递状态" show-overflow-tooltip>
      </el-table-column>
    </el-table>
    <!-- 分页组件 -->
    <Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>
    <!-- 编辑界面 -->

  </div>
</template>

<script>
  import {
    b2cordersupplierSubOrder,
    b2corderlist
  } from '../../api/userMG'
  import Pagination from '../../components/Pagination'
  export default {
    data() {
      return {
        loading: false, //是显示加载
        editFormVisible: false, //控制编辑页面显示与隐藏
        title: '预览',
        editForm: {
          id: '',
          name: '',
          payType: 1,
          partner: '',
          subMchId: '',
          appid: '',
          notifyUrl: '',
          signType: '',
          partnerKey: '',
          sellerUserId: '',
          certPath: '',
          certPassword: '',
          rsaKey: '',
          token: sessionStorage.getItem('logintoken')
        },
        formInline: {
          page: 1,
          limit: 20,
          payerUserid: '',
          spuId: this.$route.query.spuId,
          orderId: '',
          value1: '',
          type: 0
        },
        optionsorderState: '',
        // 删除部门
        seletedata: {
          ids: '',
          token: sessionStorage.getItem('logintoken')
        },
        options: [],
        userparm: [], //搜索权限
        listData: [], //用户数据
        // 分页参数
        pageparm: {
          currentPage: 1,
          pageSize: 20,
          total: 10
        }
      }
    },
    // 注册组件
    components: {
      Pagination
    },
    /**
     * 数据发生改变
     */

    /**
     * 创建完毕
     */
    created() {
      this.getdata(this.formInline)
    },

    /**
     * 里面的方法只有被调用才会执行
     */
    methods: {

      // 获取公司列表
      getdata(parameter) {
        let pro = {
          "userId": "abcdef",

          "current": parameter.page,
          "size": parameter.limit,
          spuId: parameter.spuId,
        }
        b2cordersupplierSubOrder(pro)
          .then(res => {
            this.loading = false
            if (res.code == 200) {
              this.listData = res.data.records
              // 分页赋值
              this.pageparm.currentPage = res.data.current
              this.pageparm.pageSize = res.data.size
              this.pageparm.total = res.data.total
            } else {
              this.$message({
                type: 'info',
                message: res.msg
              })
            }
          })

      },
      // 分页插件事件
      callFather(parm) {
        this.formInline.page = parm.currentPage
        this.formInline.limit = parm.pageSize
        this.getdata(this.formInline)
      },
      // 搜索事件
      search() {
        this.formInline.page = 1
        this.getdata(this.formInline)
      },

    }
  }
</script>

<style scoped>
  .user-search {
    margin-top: 20px;
  }

  .userRole {
    width: 100%;
  }
</style>



// WEBPACK FOOTER //
// src/views/b2c/user1.vue